import React from 'react';
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig';

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth/authentication/login')),
    },
    {
        key: 'sso',
        path: `${AUTH_PREFIX_PATH}/sso`,
        component: React.lazy(() => import('views/auth/authentication/sso')),
    },
    // {
    //     key: 'login-1',
    //     path: `${AUTH_PREFIX_PATH}/login-1`,
    //     component: React.lazy(() => import('views/auth/authentication/login-1')),
    // },
    // {
    //     key: 'register-1',
    //     path: `${AUTH_PREFIX_PATH}/register-1`,
    //     component: React.lazy(() => import('views/auth/authentication/register-1')),
    // },
    // {
    //     key: 'forgot-password',
    //     path: `${AUTH_PREFIX_PATH}/forgot-password`,
    //     component: React.lazy(() => import('views/auth/authentication/forgot-password')),
    // },
    {
        key: 'privacy',
        path: `privacy`,
        component: React.lazy(() => import('views/auth/privacy_policy')),
    },
    {
        key: 'term_of_user',
        path: `term_of_user`,
        component: React.lazy(() => import('views/auth/term_of_user')),
    },
    // {
    //     key: 'error-page-2',
    //     path: `${AUTH_PREFIX_PATH}/error-page-2`,
    //     component: React.lazy(() => import('views/auth/errors/error-page-2')),
    // },
];

export const protectedRoutes = [
    {
        key: 'erp-fob',
        path: `fob`,
        component: React.lazy(() => import('app_modules/erp-fob')),
    },
    {
        key: 'erp-local',
        path: `local`,
        component: React.lazy(() => import('app_modules/erp-fob')),
    },
    {
        key: 'erp-hrm',
        path: `hrm`,
        component: React.lazy(() => import('app_modules/erp-hrm')),
    },
    {
        key: 'erp-fin',
        path: `fin`,
        component: React.lazy(() => import('app_modules/erp-fin')),
    },
    {
        key: 'erp-acc',
        path: `acc`,
        component: React.lazy(() => import('app_modules/erp-acc')),
    },
    {
        key: 'erp-util',
        path: `util`,
        component: React.lazy(() => import('app_modules/erp-util')),
    },
    {
        key: 'erp-repo',
        path: `re`,
        component: React.lazy(() => import('app_modules/erp-repo')),
    },
    {
        key: 'erp-mes',
        path: `mes`,
        component: React.lazy(() => import('app_modules/erp-mes')),
    },
    {
        key: 'erp-asm',
        path: `asm`,
        component: React.lazy(() => import('app_modules/erp-asm')),
    },
    {
        key: 'erp-tms',
        path: `tms`,
        component: React.lazy(() => import('app_modules/erp-tms')),
    },
    {
        key: 'erp-qas',
        path: `qas`,
        component: React.lazy(() => import('app_modules/erp-qas')),
    },
    {
        key: 'erp-com',
        path: `com`,
        component: React.lazy(() => import('app_modules/erp-com')),
    },
    {
        key: 'erp-wss',
        path: `wss`,
        component: React.lazy(() => import('app_modules/erp-wss')),
    },
    {
        key: 'erp-eof',
        path: `eof`,
        component: React.lazy(() => import('app_modules/erp-eof')),
    },
    {
        key: 'development',
        path: 'dev',
        component: React.lazy(() => import('views/development')),
    },
    {
        key: 'sys',
        path: 'sys',
        component: React.lazy(() => import('views/systems')),
    },
];
